import { render, staticRenderFns } from "./BattlesReel.vue?vue&type=template&id=3f81fa18&scoped=true"
import script from "./BattlesReel.vue?vue&type=script&lang=js"
export * from "./BattlesReel.vue?vue&type=script&lang=js"
import style0 from "./BattlesReel.vue?vue&type=style&index=0&id=3f81fa18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f81fa18",
  null
  
)

export default component.exports